import { render, staticRenderFns } from "./SuppliesDetail.vue?vue&type=template&id=de16e382&"
import script from "./SuppliesDetail.vue?vue&type=script&lang=js&"
export * from "./SuppliesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports